































import { createComponent, ref } from "@vue/composition-api";
import BaseButton from "./BaseButton.vue";

interface Props {
  message: string;
  confirmButtonText: string;
  cancelButtonText: string;
  variant: string;
  closeOnNavigation: boolean;
}

export default createComponent<Props>({
  components: { BaseButton },
  props: {
    message: { required: true, type: String },
    confirmButtonText: { type: String, default: "OK" },
    cancelButtonText: { type: String, default: "Anuluj" },
    variant: { type: String, default: "danger" },
    closeOnNavigation: { type: Boolean, default: false },
  },
  setup(props, ctx) {
    const visible = ref(false);

    return {
      visible,
      openDialog: () => (visible.value = true),
      closeDialog: () => (visible.value = false),
      onConfirm: () => {
        visible.value = false;
        ctx.emit("click");
      },
    };
  },
});
